import { render, staticRenderFns } from "./custom-funnel-view.vue?vue&type=template&id=f3aa54f4&scoped=true&"
import script from "./custom-funnel-view.vue?vue&type=script&lang=ts&"
export * from "./custom-funnel-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aa54f4",
  null
  
)

export default component.exports